import { ATTENDEE_ROLE_LABEL, AttendeeRole } from '@/constants'
import { ScriptAttendee } from '@/types'

// An errata sheet goes to the deponent's side, never to the people running the
// proceeding, so those roles are not offered as recipients at all.
const REPORTER_SIDE_ROLES: AttendeeRole[] = [
  AttendeeRole.COURT_REPORTER,
  AttendeeRole.DIGITAL_REPORTER,
  AttendeeRole.SESSION_ASSISTANT,
  AttendeeRole.VIDEOGRAPHER,
]

// The sheet usually goes to the attorney answering for the witness, and
// otherwise to the witness, so both are lifted to the top of the list.
const PREFERRED_ROLES: AttendeeRole[] = [
  AttendeeRole.WITNESS_ATTORNEY,
  AttendeeRole.WITNESS,
]

const preference = (attendee: ScriptAttendee): number => {
  const index = PREFERRED_ROLES.indexOf(attendee.role)

  return index === -1 ? PREFERRED_ROLES.length : index
}

export const getErrataRecipientOptions = (
  attendees: ScriptAttendee[],
): { value: string; label: string }[] =>
  attendees
    .filter(attendee => !REPORTER_SIDE_ROLES.includes(attendee.role))
    .map((attendee, index) => ({ attendee, index }))
    .sort(
      (a, b) =>
        preference(a.attendee) - preference(b.attendee) || a.index - b.index,
    )
    .map(({ attendee }) => ({
      value: attendee.attendee_id,
      label: `${attendee.name} — ${ATTENDEE_ROLE_LABEL[attendee.role]}`,
    }))
